/** Build multiline address text for order / checkout form from a saved address object */
export function formatSavedAddressForOrder(addr) {
  if (!addr) return "";
  const lines = [
    `City: ${addr.city}`,
    `Area: ${addr.area}`,
    `Street: ${addr.street}`,
  ];
  if (addr.building && String(addr.building).trim()) {
    lines.push(`Building / Apt: ${addr.building}`);
  }
  if (addr.notes && String(addr.notes).trim()) {
    lines.push(`Address notes: ${addr.notes}`);
  }
  return lines.join("\n");
}

/** Short one-line summary for radio list */
export function formatSavedAddressSummary(addr) {
  if (!addr) return "";
  const parts = [
    addr.city,
    addr.area,
    addr.street,
    addr.building,
  ].filter((x) => x && String(x).trim());
  return parts.join(", ") || "Address";
}
